/* eslint-disable no-nested-ternary */
/* eslint-disable func-names */
/* eslint-disable react/destructuring-assignment */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { TextField } from '@material-ui/core';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const CodeTableCustomTextField = (props) => {
  const compareRebateCodeSearchResult = useSelector(
    (state) =>
      state?.sharedState?.CodeTableReducer?.compareRebateCodeSearchResult
  );
  const isDuplicate = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.isDuplicate
  );
  const parentrow = useSelector(
    (state) => state?.sharedState?.CodeTableReducer?.parentrow
  );

  const checkedHandler = (e) => {
    const { colId } = props?.column;
    const inputValue = e.target.value;

    props.node.setDataValue(colId, inputValue === '' ? null : inputValue);

    optimiseValidationCall(props, compareRebateCodeSearchResult);
  };

  const debounce = (func) => {
    let timer;
    return function (...args) {
      const context = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, 300);
    };
  };

  const optimiseValidationCall = useCallback(
    debounce(props?.validateBtnDisable),
    []
  );

  return (
    <div
      className={`fullWidth w-100 text-left td-active-cell ${
        (props?.required && (!props?.value || !props?.value.trim())) ||
        (isDuplicate?.value === props?.value && isDuplicate?.duplicate)
          ? 'tBill-validate'
          : ''
      }`}
      id="description"
    >
      {props && props.value && props.value.length > 25 ? (
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="filter-tooltip">{props?.value || ''}</Tooltip>}
        >
          <TextField
            fullWidth
            placeholder=""
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              maxlength:
                props?.column?.colId === 'shortDescription'
                  ? 30
                  : props?.column?.colId === 'longDescription'
                  ? 255
                  : 10,
              disableUnderline: true,
              'aria-labelledby': 'description',
            }}
            disabled={props?.isReadOnly || props?.disabled || false}
            value={props?.value || ''}
            onChange={checkedHandler}
            error={props?.required && (!props?.value || !props?.value.trim())}
            helperText=""
            onKeyDown={(e) => {
              // console.log(props.addAction);
              // if (
              //   !props?.isReadOnly &&
              //   !props?.disabled &&
              //   props?.column?.colId === 'longDescription' &&
              //   ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight')
              // ) {
              //   props.addAction(e, parentrow);
              // }
            }}
          />
        </OverlayTrigger>
      ) : (
        <TextField
          fullWidth
          placeholder=""
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            maxlength:
              props?.column?.colId === 'shortDescription'
                ? 30
                : props?.column?.colId === 'longDescription'
                ? 255
                : 10,
            disableUnderline: true,
            'aria-labelledby': 'description',
          }}
          disabled={props?.isReadOnly || props?.disabled || false}
          value={props?.value || ''}
          onChange={checkedHandler}
          error={props?.required && (!props?.value || !props?.value.trim())}
          helperText=""
          onKeyDown={(e) => {
            // console.log(
            //   props.isReadOnly,
            //   props?.disabled,
            //   props?.column?.colId,
            //   e.key
            // );
            // if (
            //   !props?.isReadOnly &&
            //   !props?.disabled &&
            //   props?.column?.colId === 'longDescription' &&
            //   ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowRight')
            // ) {
            //   props.addAction(e, parentrow);
            // }
          }}
        />
      )}
    </div>
  );
};

export default CodeTableCustomTextField;
